import type { FormData, EvaluationType_Option } from "../types";

interface EvaluationHeaderProps {
  formData: FormData;
  evaluationTypes: EvaluationType_Option[];
}

export const EvaluationHeader: React.FC<EvaluationHeaderProps> = ({
  formData,
  evaluationTypes,
}) => {
  const evaluationType = evaluationTypes.find((t) => t.id === formData.type);

  return (
    <div className="text-center mb-8">
      <h2 className="text-2xl font-bold text-indigo-900 mb-3">
        {formData.title}
      </h2>
      <div className="flex justify-center gap-6 text-sm text-gray-700">
        <span>
          <strong>Tipo:</strong> {evaluationType?.label}
        </span>
        <span>
          <strong>Valor:</strong> {formData.weight} pontos
        </span>
      </div>
    </div>
  );
};
